function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M87,5H13c-2.2,0-4,1.8-4,4v82c0,2.2,1.8,4,4,4h20h34h20c2.2,0,4-1.8,4-4V9C91,6.8,89.2,5,87,5z M37,91V71h26v20H37z M67,91  V71c0-2.2-1.8-4-4-4H37c-2.2,0-4,1.8-4,4v20H13V9h74l0,82H67z M53,54c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S53,52.3,53,54z M69,54  c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S69,52.3,69,54z M37,22c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S37,20.3,37,22z M37,54  c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S37,52.3,37,54z M37,38c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S37,36.3,37,38z M53,22  c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S53,20.3,53,22z M53,38c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S53,36.3,53,38z M69,22  c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S69,20.3,69,22z M69,38c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S69,36.3,69,38z"
});

var _ref3 = /*#__PURE__*/React.createElement("text", {
  x: 0,
  y: 115,
  fill: "#000000",
  fontSize: "5px",
  fontWeight: "bold",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
}, "Created by IconMark");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 0,
  y: 120,
  fill: "#000000",
  fontSize: "5px",
  fontWeight: "bold",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
}, "from the Noun Project");

var SvgOrganization = function SvgOrganization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrganization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/organization.e7f17c9c.svg";
export { ForwardRef as ReactComponent };